export default __webpack_public_path__ + "static/media/im.d47ec035.svg";